<template>
  <div
    class="total-profit"
    :class="{ 'blance-bgc': $store.state.sideMenuId !== 'dashboard' }">
    <div class="total-profit__title">収益合計</div>
    <div
      class="total-profit__price"
      :class="{ 'blance-padding': $store.state.sideMenuId !== 'dashboard' }">
      ¥{{ paymentBalance | roundNumber }}
    </div>
    <div
      v-show="true"
      class="c-btn-wrap c-btn-wrap--total-price">
      <router-link
        v-if="$store.state.sideMenuId === 'dashboard'"
        :to="{ name : 'balance' }"
        class="c-btn">
        {{ buttonTitle }}
        <span class="c-btn__icon-arrow"></span>
      </router-link>
      <div
        v-else-if="subscriptionCarrierFeePending"
        v-show="!hidenPayment"
        class="c-btn"
        @click.prevent="showDialog=true">
        {{ buttonTitle }}
        <span class="c-btn__icon-arrow"></span>
      </div>
      <router-link
        v-else
        v-show="!hidenPayment"
        :to="{ name : 'withdrawal' }"
        class="c-btn">
        {{ buttonTitle }}
        <span class="c-btn__icon-arrow"></span>
      </router-link>
    </div>
    <router-link
      v-show="!hide"
      :to="{ name : 'report-finalized' }"
      class="c-text-link">
      確定レポートを見る
    </router-link>
    <confirm-dialog
      name="subscriptionCarrierFeePending"
      :is-shown="showDialog"
      :default-button-title="'決済情報を更新する'"
      :cancel-button-title="false"
      title="支払い申請を行うことができません"
      @closed="showDialog = false"
      @default-clicked="onSubscriptionCarrierFeePendingClicked">
      <template #body>
        支払い申請を行うためには<br>決済情報を更新する必要があります。
      </template>
    </confirm-dialog>
  </div>
</template>

<script>
import ConfirmDialog from '../../../../components/ConfirmDialog'

export default {
  name: 'BalanceReport',
  components: {
    ConfirmDialog,
  },
  filters: {
    roundNumber(value) {
      return value
        ? new Intl.NumberFormat('ja-JP').format(Math.round(value * 100) / 100)
        : 0
    },
  },
  props: {
    hide: {
      type: Boolean,
      default: false,
    },
    hidenPayment: {
      type: Boolean,
      default: false,
    },
    buttonTitle: {
      type: String,
      default: '支払い申請',
    },
    subscriptionCarrierFeePending: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paymentBalance: '',
      showDialog: false,
    }
  },
  mounted() {
    this.fetchBalance()
  },
  methods: {
    async fetchBalance() {
      const { data } = await window.axios.get('/api/client/payments/balances')
      this.paymentBalance = data
    },
    onSubscriptionCarrierFeePendingClicked() {
      this.$router.push({ name: 'settlement-method-change' })
    },
  },
}
</script>

<style scoped>
.blance-bgc {
  background-color: #f3f3f1;
}
.blance-padding {
  padding: 15px 0 10px;
}
</style>
